body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.tiptap-image-wrapper {
  display: inline-block;
  position: relative;
}

.tiptap-image-wrapper img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Constrain images in viewer mode */
.ProseMirror img {
  max-width: 100%;
  height: auto;
}

.tiptap-image {
  max-width: 100%;
  height: auto;
  display: inline-block;
}

.tiptap-viewer-image {
  max-width: 100% !important;
  height: auto !important;
  display: inline-block;
}
